import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { GoogleCalendarIntegrationResponse } from 'src/queries/organizations/calendarIntegrations/calendarIntegrations.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

const googleCalendarIntegrationUrl = (orgId: string) =>
  `/organizations/${orgId}/calendar-integrations/google`

export const getGoogleCalendarIntegration = async (
  orgId: string,
): Promise<GoogleCalendarIntegrationResponse> => {
  return getResponseData(
    axios.get<GoogleCalendarIntegrationResponse>(
      googleCalendarIntegrationUrl(orgId),
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const connectGoogleCalendarIntegration = async (
  orgId: string,
): Promise<GoogleCalendarIntegrationResponse> => {
  return getResponseData(
    axios.put<GoogleCalendarIntegrationResponse>(
      googleCalendarIntegrationUrl(orgId),
      undefined,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const disconnectGoogleCalendarIntegration = async (
  orgId: string,
): Promise<GoogleCalendarIntegrationResponse> => {
  return getResponseData(
    axios.delete<GoogleCalendarIntegrationResponse>(
      googleCalendarIntegrationUrl(orgId),
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
